import { API } from "@/lib/api";
import { APIService, FetchListRequestParams } from "@/services/api";
import {
  DefaultStoreProjectAssigneeUpdate,
  DefaultStoreProjectAssigneeListItem,
  ReadDefaultStoreProjectAssignee,
  DefaultStoreProjectAssigneeCreateResponse,
  DefaultStoreProjectAssigneeCreate,
  DefaultStoreProjectAssigneeUpdateResponse,
} from "@/types/defaultStoreProjectAssignee";

const service = new APIService<
  DefaultStoreProjectAssigneeListItem,
  DefaultStoreProjectAssigneeCreate
>(API.DefaultStoreProjectAssignees);

export const DefaultStoreProjectAssigneesService = {
  getList: (
    params: FetchListRequestParams<DefaultStoreProjectAssigneeListItem>,
  ) => service.getList(params),
  post: (data: DefaultStoreProjectAssigneeCreate) =>
    service.post<
      DefaultStoreProjectAssigneeCreate,
      DefaultStoreProjectAssigneeCreateResponse
    >(data),
  getById: (id: string) => service.get<ReadDefaultStoreProjectAssignee>(id),
  update: (id: string, data: DefaultStoreProjectAssigneeUpdate) =>
    service.patch<
      DefaultStoreProjectAssigneeUpdate,
      DefaultStoreProjectAssigneeUpdateResponse
    >(id, data),
  delete: (id: string) => service.delete(id),
};
